import client from "../utils/client";
import { productsListUrl } from "../store/constants/api";
import {
  addProductUrl,
  addVariantUrl,
  editProductUrl,
  editVariantUrl,
  showVariantUrl,
} from "../store/constants/api";
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const productService = {
  productsListResponse,
  productsListSort,
  addProductRequest,
  _addVariantRequest,
  _editVariantRequest,
  editProductRequest,
  getProductResponse,
  _deleteVariantRequest,
};

function productsListSort(pageID, perPage, search, sort = "") {
  return client
    .get(productsListUrl + "?page=" + pageID + "&per_page=" + perPage + sort)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function productsListResponse(pageID, perPage, searchInput, sort = "") {
  let searchQuery = "";
  if (searchInput !== "") {
    searchQuery = "&s=" + searchInput;
  }
  return client
    .get(
      productsListUrl +
        "?page=" +
        pageID +
        "&per_page=" +
        perPage +
        searchQuery +
        sort
    )
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function addProductRequest(formData) {
  return client
    .post(addProductUrl, formData)
    .then((response) => {
      if (response.data.status == "success") return response;
    })
    .catch(handleResponse);
}

function editProductRequest(formData) {
  return client
    .post(editProductUrl, formData)
    .then((response) => {
      if (response.data.status == "success") return "success";
    })
    .catch(handleResponse);
}

function _addVariantRequest(variantData, productID) {
  variantData.product_id = productID;
  return client
    .post(addVariantUrl, variantData)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function _deleteVariantRequest(variantID) {
  return client
    .get(showVariantUrl + "/" + variantID + "/delete")
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function _editVariantRequest(variantData, productID) {
  variantData.product_id = productID;
  return client
    .post(editVariantUrl, variantData)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function getProductResponse(productID) {
  return client
    .get(productsListUrl + "/" + productID + "/show")
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
